import { useSearchParams } from 'hooks'
import { useEffect } from 'react'
import { UTM } from 'typings'
import { UTM_VALID_CHARS } from '../UTMField'

function filterUnique(values: string[]): string[] {
  return Array.from(new Set(values))
}

function filterValidChars(values: string[]): string[] {
  return values.filter((value) => UTM_VALID_CHARS.test(value))
}

function filterEmpty(values: string[]): string[] {
  return values.filter((value) => !!value)
}

/**
 * Apply filters to UTMs values
 * Valid Chars from packages/ui/components/PromotionForm/Conditions/UTM/UTMField.tsx
 * Repeated and non-empty values from packages/ui/components/PromotionForm/MultiInput/MultiInput.tsx
 * @returns Valid UTMs values
 */
function filterUTMs(utms: UTM): UTM {
  return {
    utmSource: filterEmpty(filterUnique(filterValidChars(utms.utmSource))),
    utmCampaign: filterEmpty(filterUnique(filterValidChars(utms.utmCampaign))),
  }
}

type Props = {
  update: (values: UTM, clear: boolean) => void
}

export function useUTMsSearchParams(props: Props) {
  const { update } = props
  const { params } = useSearchParams()

  useEffect(() => {
    const utmParams = {
      utmSource: params.get('utmSource')?.split(',') ?? [],
      utmCampaign: params.get('utmCampaign')?.split(',') ?? [],
    }
    update(filterUTMs(utmParams), false)
  }, [update, params])
}
